export default {"src":"/_next/static/media/boogschieten.05f4a9da.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};